import CrossIcon from "assets/icons/CrossIcon";
import { CSSProperties, ReactNode } from "react";

interface Props {
  title: string;
  open?: boolean;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  style?: {
    container?: CSSProperties;
    header?: CSSProperties;
    body?: CSSProperties;
    footer?: CSSProperties;
  };
}

export default function ModalBox({ open, children, onClose, title, footer, style }: Props) {
  return (
    <div
      id="backdrop"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // overflow: "auto",
      }}
    >
      <div
        id="container"
        style={{
          width: "90%",
          display: "flex",
          maxHeight: "90%",
          flexDirection: "column",
          gap: "2px",
          backgroundColor: "#DCDCDC",
          borderRadius: "8px",
          ...(style?.container || {}),
        }}
      >
        <div
          id="header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "16px 24px",
            backgroundColor: "#ffffff",
            borderRadius: "8px 8px 0px 0px",
            ...(style?.header || {}),
          }}
        >
          <span onClick={onClose} style={{ cursor: "pointer", color: "#3D3D3D" }}>
            <CrossIcon color="#95A3B5" />
          </span>
          <span dir="rtl">{title}</span>
        </div>
        <div
          id="body"
          style={{
            backgroundColor: "#ffffff",
            // minHeight: "600px",
            overflowY: "auto",
            position:"relative",
            borderRadius: footer ? 0 : "0px 0px 8px 8px",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            direction: "rtl",
            ...(style?.body || {}),
          }}
        >
          {children}
        </div>
        {footer && (
          <div
            id="footer"
            style={{
              display: "flex",
              placeItems: "center",
              padding: 16,
              minHeight: 60,
              backgroundColor: "#ffffff",
              borderRadius: "0px 0px 8px 8px",
              direction: "rtl",
              ...(style?.body || {}),
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
